<div class="d-flex flex-column flex-center mt-30 mt-lg-0 login-container">
  <!--begin::Signin-->
  <div class="login-form login-signin">
    <div class="text-center mb-5 mb-lg-15">
      <h3 class="font-size-h1">Iniciar sesión / Sign In</h3>
      <p *ngIf="!stepTwo" class="text-muted font-weight-bold">Ingresa tu correo electrónico y tu contraseña / Use your email and password</p>
      <p *ngIf="stepTwo" class="text-muted font-weight-bold">Ingresa el código de verificación</p>
    </div>

    <br-alert *ngIf="showAlert"></br-alert>

    <form *ngIf="stepTwo" [formGroup]="loginForm" autocomplete="off" novalidate="novalidate" id="kt_login_otp">
      <div class="mb-2">
        <h3>{{ newCodeMess ? "¡Nuevo código enviado!" : "¡Código enviado!" }}</h3>
      </div>
      <h4>
        <span>Escribe a continuación el código de verificación que llegó a tu correo:</span>
        <strong class="ml-1">{{ loginForm.value.email || "-" }}</strong>
      </h4>

      <div class="mb-2 mt-2">
        <strong>Escribe el código:</strong>
      </div>
      <lib-input-code [size]="sizeCode" [loading]="loadingCode" (codeResult)="handleCode($event)" (codeClear)="resetCode()" [error]="errorCode" [success]="successCode" [bus]="codeBus"></lib-input-code>

      <div class="mt-2" appRecaptcha (recaptchaSuccess)="onRecaptchaSuccess($event)" (recaptchaError)="onRecaptchaError($event)" (recaptchaExpired)="resetRecaptcha()"></div>
      <p *ngIf="disableMess" class="my-0" [ngStyle]="{ color: 'red' }">Completa el captcha / Complete the captcha</p>

      <div class="form-group d-flex flex-wrap justify-content-between align-items-center pt-1 pb-0">
        <button
          id="kt_otp_signin_submit"
          (click)="submit(loginForm)"
          [ngClass]="{
            'spinner spinner-right spinner-md spinner-light': loading
          }"
          class="btn btn-primary font-weight-bold px-9 py-4 mt-3"
        >
          Validar código / Check code
        </button>
        <p *ngIf="newCode" id="kt_newotp_signin_submit" (click)="newOTP(loginForm)" style="margin: 10px 0 0 !important; font-weight: 600; cursor: pointer">Enviar código nuevo / Send a new code</p>
      </div>
    </form>

    <!--begin::Form-->
    <form class="form" *ngIf="!stepTwo" [formGroup]="loginForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
      <div class="form-group pt-0">
        <mat-form-field>
          <mat-label>Correo electrónico / Email</mat-label>
          <input matInput type="email" formControlName="email" style="text-transform: lowercase" autocomplete="off" />
          <mat-error *ngIf="isControlHasError('email', 'required')">
            <strong>Campo requerido / required field</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('email', 'email')">
            <strong>Correo electrónico invalido / invalid email</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group pt-0">
        <mat-form-field appearance="fill">
          <mat-label>Contraseña / Password</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" autocomplete="off" />
          <mat-icon matSuffix (click)="hide = !hide">{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
          <mat-error *ngIf="isControlHasError('password', 'required')">
            <strong>Campo requerido / required field</strong>
          </mat-error>
        </mat-form-field>
        <a href="javascript:;" routerLink="/auth/forgot-password" class="font-weight-bold" id="kt_login_forgot">¿Olvidaste tu contraseña? / Forgot password?</a>
      </div>
      <!-- ReCaptcha-->
      <div appRecaptcha (recaptchaSuccess)="onRecaptchaSuccess($event)" (recaptchaError)="onRecaptchaError($event)" (recaptchaExpired)="resetRecaptcha()"></div>
      <p *ngIf="disableMess" class="my-0" [ngStyle]="{ color: 'red' }">Completa el captcha / Complete the captcha</p>
      <!--begin::Action-->
      <div class="form-group d-flex flex-wrap justify-content-between align-items-center pt-1 pb-0">
        <button
          id="kt_login_signin_submit"
          (click)="submit(loginForm)"
          [ngClass]="{
            'spinner spinner-right spinner-md spinner-light': loading
          }"
          class="btn btn-primary font-weight-bold px-9 py-4 mt-3"
        >
          Iniciar sesión / Log In
        </button>
      </div>
      <!-- ReCaptcha -->
      <!--end::Action-->
    </form>
    <!--end::Form-->

    <div class="form-group">
      <button mat-button (click)="openDialog()">Términos y Condiciones / Privacy Policy</button>
      <p class="font-weight-bold text-dark-50 links text-justify">Al iniciar sesión en Asegúrate Cargo, aceptas nuestros <a href="javascript:;">Acuerdos de licencia</a>, <a href="javascript:;">Política de confidencialidad</a> y <a href="javascript:;">Condiciones de uso</a>.</p>
      <p class="text-muted font-weight-bold text-justify">Te recomendamos usar los navegadores Web Chrome 84 o superior, Firefox 80 o superior, Safari 14 o superior, Microsoft Edge 85 o superior.</p>
      <p class="font-weight-bold text-dark-50 links text-justify">By logging you agree to our <a href="javascript:;">License Agreements</a>, <a href="javascript:;">Privacy Policy</a> and <a href="javascript:;">Term of Use</a>.</p>
      <p class="text-muted font-weight-bold text-justify">We recommend Chrome 84 or higher, Firefox 80 or higher, Safari 14 or higher, Microsoft Edge 85 or higher browsers.</p>
    </div>
  </div>
  <!--end::Signin-->
  <div class="company-info">
    <div class="mb-5 d-flex justify-content-center">
      <a href="https://twitter.com/AsegurateColombia" target="_blank">
        <img src="../../../../assets/media/logos/twitter.png" alt="twitter" />
      </a>
      <a href="https://www.facebook.com/Aseguratecolombia/" target="_blank">
        <img src="../../../../assets/media/logos/facebook.png" alt="facebook" style="margin-left: 7px" />
      </a>
      <a href="https://linkedin.com/company/Asegurate-s-a-s/" target="_blank">
        <img src="../../../../assets/media/logos/linkedin.png" alt="linkedin" style="margin-left: 7px" />
      </a>
    </div>
    <p class="text-muted font-weight-bold text-justify">Teléfono / Phone: (+57 1) 255 9532 | Celular / Mobile: (+57) 318 706 8636 | Dirección / Address: Calle 71A # 17 – 35 Of. 303 Bogotá - Colombia | contacto@aseguratelimitada.com | <a href="http://www.aseguratelimitada.com/" target="_blank">www.aseguratelimitada.com</a></p>
  </div>
</div>
